export enum ComplianceHttpPaths {
  complianceDocuments = '/api/v1.0/compliance-documents',
  complianceSummary = '/api/v1.0/compliance-documents/summary',
  callCentreStatus = '/api/v1.0/staff/call-centre-status',
  updateCompliance = '/api/v1.0/compliance-documents/update',
  downloadComplianceCertificate = '/api/v1.0/compliance-documents/{###}/certificate',
  updateUrl = '/api/v1.0/compliance-documents/{###}/update-url',
}
